import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <section className="hero">
            <h2>Book Bazaar</h2>
            <h3>"A book is a dream that you hold in your hand."<br /> - Neil Gaiman</h3>
            <Link className="btn" to="/books">View All Books</Link>
        </section>
    )
}

export default Hero
